import { DialogContentText } from "@mui/material";
import TeambookTextForm from "../../../default_components/TeambookTextForm";
import { useTranslation } from "react-i18next";
import TeambookDialog from "../../../default_components/TeambookDialog";
import PropTypes from "prop-types";

export const EmailChangingModal = ({
  closeEmailChangingModal,
  emailChangingMenuOpen,
  setNewEmail,
  newEmail,
  errorMessage,
  errorField,
  closeErrorMessage,
  switchEmailModals,
}) => {
  const { t } = useTranslation();

  return (
    <TeambookDialog
      open={emailChangingMenuOpen}
      title={t("profile.email.email_changing")}
      onClose={() => {
        closeEmailChangingModal();
        setNewEmail("");
      }}
      withCloseButton
      content={
        <>
          <DialogContentText>
            <p>{t("profile.email.enter_new_mail")}</p>
          </DialogContentText>

          <TeambookTextForm
            fieldName={t("profile.email.new_email")}
            onChange={setNewEmail}
            fieldValue={newEmail}
            id={"newEmail"}
            type={"text"}
            width={"270px"}
            errorField={errorField}
            errorMessage={errorMessage}
            closeErrorMessage={closeErrorMessage}
            field={"new_email"}
          />
        </>
      }
      actionButtons={[
        { text: t("submit"), onClick: switchEmailModals },
      ]}
    />
  );
};

EmailChangingModal.propTypes = {
  closeEmailChangingModal: PropTypes.func.isRequired,
  emailChangingMenuOpen: PropTypes.bool.isRequired,
  setNewEmail: PropTypes.func.isRequired,
  newEmail: PropTypes.string.isRequired,
  errorMessage: PropTypes.string,
  errorField: PropTypes.string,
  closeErrorMessage: PropTypes.func.isRequired,
  switchEmailModals: PropTypes.func.isRequired,
}
